const TODAY = new Date();
const IN_ONE_YEAR = new Date(TODAY.getFullYear() + 1, TODAY.getMonth(), TODAY.getDate());
const SIX_WEEKS_AGO = new Date(TODAY.getTime() - 42 * 24 * 60 * 60 * 1000);

// yyyy-mm-dd
const format = (value: Date) => value.toISOString().split('T')[0];

export const TODAY_FORMATTED = format(TODAY);
export const IN_ONE_YEAR_FORMATTED = format(IN_ONE_YEAR);
export const SIX_WEEKS_AGO_FORMATTED = format(SIX_WEEKS_AGO);

export const getCurrentMonth = () =>
  new Date().toLocaleDateString('de-DE', {
    timeZone: 'Europe/Berlin',
    month: 'long',
  });
